
    import {Component, Vue, Watch} from "vue-property-decorator";
    import statisticApi from "@/api/statistic";

    const {CodeToText, regionData} = require("@/js/region/region");
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import {IPage} from "@/js/page";
    import {dictApi} from "@/api/organization";

    @Component({
        name: "Inspect_Index",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        mode = 'Inspect_Order'; // or Inspect_Instr  强检器具检定汇总  或 报检强检器具业务汇总
        dataList = []; //数据列表
        CodeToText = CodeToText;
        regionData = regionData;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        levelData = {};
        mechanismLevelList = []; //单位级别
        purposeCodeList = []; //器具用途
        instrCatalogueTree = []; //强检目录
        propParam = {
            mechanismName: '', //机构名称
            mechanismRegion: '', //机构区域
            mechanismLevel: '', //机构级别
            initiatorMechanismName: '', //使用单位
            checkStatus: '', //业务状态
            checkResult: '', //检定状态
            instrName: '',//器具名称
            purposeCode: '', //器具用途
            catalogue: [], //器具目录
            startTime: '',
            endTime: '',
        } as any;
        tabCol = [];
        tableKey = 0;
        loading = false;
        showForm = false;
        private exportExcel: any;
        listTotal = 0;
        listParam: IPage = {
            size: 100,
            current: 1,
        };

        mounted() {

            //单位区域
            // statisticApi.getMechanismRegion().then((r) => {
            //     const regionCode = r.data.data;
            //     if(regionCode == null){
            //         this.regionData = regionData;
            //     }else{
            //         const region = this.getRegionData(regionCode, regionData);
            //         this.regionData = [ region ];
            //     }
            // });

            //单位级别
            dictApi.listDictItem({typeCode: "dwjb"}).then((r) => {
                if (r.data.result === 0) {
                    const levels = r.data.data;
                    this.mechanismLevelList = levels;
                    this.levelData = Object.fromEntries(levels.map((item: any) => [item.dictKey, item]));
                }
            });
            //器具用途
            dictApi.list({
                category: 2,
            }).then(r=>{
                if(r.data.result === 0){
                    this.purposeCodeList = r.data.data
                }
            })
            //器具目录
            dictApi.listInstrumentCatalogueTree().then((r) => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTreeV2(rData);
                    this.instrCatalogueTree = rData;
                }
            });
            this.loadDataList(null);
        }

        getRegionData(regionCode: number, projectList: any) : any{
            for (let i = 0; i < projectList.length; i++) {
                let treeItem= projectList[i]
                if(treeItem.value === regionCode ){
                    return treeItem
                }else{
                    if(treeItem.children && treeItem.children.length>0){
                        const res = this.getRegionData(regionCode, treeItem.children);
                        if(res){
                            return res;
                        }
                    }
                }
            }
        }

        refresh(){
            this.loadDataList(null);
        }
        porjectTreeV2(projectList: any){
            projectList.forEach((project: any) => {
                if(project.children.length == 0){
                    project.children = null;
                }else{
                    this.porjectTreeV2(project.children);
                }
            })
        }
        reset(){
            for(const f in this.propParam){
                this.propParam[f] = "";
            }
            this.refresh();
        }

        indexMethod(index: any) {
            return this.listTotal - ((this.listParam.current - 1) * this.listParam.size + index);
        }
        changeTab(){
            this.loadDataList(null);
        }
        changeTabCol(e: any) {
            this.tabCol = e;
            this.tableKey = Math.random();
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
            })
        }
        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.loadDataList(null);
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.loadDataList(null);
        }
        loadDataList(callback:  any) {
            this.loading = true;
            const params = {
                ...this.listParam,
                ...this.propParam,
            } as any;
            if(params.catalogue.length > 0){
                params.catalogueOne = params.catalogue[0];
            }
            if(params.catalogue.length > 1){
                params.catalogueTwo = params.catalogue[1];
            }
            params.catalogue = null;
            let api = null;
            if(this.mode === 'Inspect_Order'){
                api = statisticApi.listInspectOrderApp(params);
            }else{
                api = statisticApi.listInspectInstrApp(params);
            }
            api.then((r) => {
                if (r.data.result === 0) {
                    const {records, total} = r.data.data;
                    this.dataList = records;
                    this.listTotal = total;
                    if(callback){
                        callback();
                    }
                }
                this.loading = false;
            });
        }

        onExportExcel() {
            this.loading = true;
            const listParam = JSON.parse(JSON.stringify(this.listParam));
            this.listParam.current = -1;
            this.loadDataList(() => {
                this.exportExcel(() => {
                    this.listParam = listParam;
                    this.loadDataList(() => {
                        this.loading = false;
                    });
                }, (this.mode == 'Inspect_Order' ? '本区域强检器具报检申请汇总' : '本区域报检强检器具业务汇总') + ".xlsx");
            });
        }
    }
